/**
 * External Dependencies
 */
import 'bootstrap';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/*
import helpers
 */
import PluginManager from 'src/plugin-system/plugin.manager';
import ViewportDetection from 'src/helper/viewport-detection.helper';
import NativeEventEmitter from 'src/helper/emitter.helper';

/*
import plugins
 */
import LazyLoadPlugin from './plugin/lazy-load/lazy-load.plugin';
import ImageCaptionSliderPlugin from './plugin/image-caption-slider/image-caption-slider.plugin';
import BackToTopPlugin from './plugin/back-to-top/back-to-top.plugin';
import BrowserUpdatePlugin from './plugin/browser-update/browser-update.plugin';
import PreloaderPlugin from './plugin/preloader/preloader.plugin';
import ThermoOelPeopleGridSliderPlugin from './plugin/thermo-oel-people-grid-slider/thermo-oel-people-grid-slider.plugin';
import TransitionLoaderPlugin from './plugin/transition-loader/transition-loader.plugin';
import CustomNavPillsPlugin from './plugin/custom-nav-pills/custom-nav-pills.plugin';
import FooterPlugin from './plugin/footer/footer.plugin';
import HeaderPlugin from './plugin/header/header.plugin';
import VomSchockenZumBackenPlugin from './plugin/vom-schocken-zum-backen/vom-schocken-zum-backen.plugin';
import InternationalMapPlugin from './plugin/international-map/international-map.plugin';
import HeroPlugin from './plugin/hero/hero.plugin';
import ScreensaverPlugin from './plugin/screensaver/screensaver.plugin';
import CustomTabsPlugin from './plugin/custom-tabs/custom-tabs.plugin';
import ProductHeroImagesPlugin from './plugin/product-hero-images/product-hero-images.plugin';
import AnimationsPlugin from './plugin/animations/animations.plugin';
import SearchPlugin from './plugin/search/search.plugin';
import ImageSliderPlugin from './plugin/image-slider/image-slider.plugin';
import AktuelleThemenSliderPlugin from './plugin/aktuelle-themen-slider/aktuelle-themen-slider.plugin';
import ProductsSliderPlugin from './plugin/products-slider/products-slider.plugin';
import VideoPlayPlugin from './plugin/video-play/video-play.plugin';
import ZeitstrahlPlugin from './plugin/zeitstrahl/zeitstrahl.plugin';
import ThermoOelAnimationPlugin from './plugin/thermo-oel-animation/thermo-oel-animation.plugin';
import AuszeichnungenPlugin from './plugin/auszeichnungen/auszeichnungen.plugin';
import ExpertenSliderPlugin from './plugin/experten-slider/experten-slider.plugin';
import BesteBackergebnissePlugin from './plugin/beste-backergebnisse/beste-backergebnisse.plugin';
import ImFokusSliderPlugin from './plugin/im-fokus-slider/im-fokus-slider.plugin';
import BacktechnologieAnimationPlugin from './plugin/backtechnologie-animation/backtechnologie-animation.plugin';
import TypographyPlugin from './plugin/typography/typography.plugin';
window.eventEmitter = new NativeEventEmitter();

/*
initialisation
*/
new ViewportDetection();

/*
register plugins
*/
PluginManager.register('LazyLoad', LazyLoadPlugin);
PluginManager.register('BrowserUpdate', BrowserUpdatePlugin);
PluginManager.register('Animations', AnimationsPlugin);
PluginManager.register('Search', SearchPlugin, '[data-search]');
PluginManager.register('ImageCaptionSlider', ImageCaptionSliderPlugin, '[data-image-caption-slider]');
PluginManager.register('BacktechnologieAnimation', BacktechnologieAnimationPlugin, '[data-backtechnologie-animation]');
PluginManager.register('Auszeichnungen', AuszeichnungenPlugin, '[data-auszeichnungen]');
PluginManager.register('Footer', FooterPlugin, '[data-footer]');
PluginManager.register('Screensaver', ScreensaverPlugin, '[data-screensaver]');
PluginManager.register('BesteBackergebnisse', BesteBackergebnissePlugin, '[data-beste-backergebnisse]');
PluginManager.register('BackToTop', BackToTopPlugin, '[data-back-to-top]');
PluginManager.register('Hero', HeroPlugin, '[data-hero]');
PluginManager.register('VomSchockenZumBacken', VomSchockenZumBackenPlugin, '[data-vom-schocken-zum-backen]');
PluginManager.register('ThermoOelAnimation', ThermoOelAnimationPlugin, '[data-thermo-oel-animation]');
PluginManager.register('InternationalMap', InternationalMapPlugin, '[data-international-map]');
PluginManager.register('Zeitstrahl', ZeitstrahlPlugin, '[data-zeitstrahl]');
PluginManager.register('CustomTabs', CustomTabsPlugin, '[data-custom-tabs]');
PluginManager.register('ThermoOelPeopleGridSlider', ThermoOelPeopleGridSliderPlugin, '[data-thermo-oel-people-grid-slider]');
PluginManager.register('ImageSlider', ImageSliderPlugin, '[data-image-slider]');
PluginManager.register('AktuelleThemenSlider', AktuelleThemenSliderPlugin, '[data-aktuelle-themen-slider]');
PluginManager.register('ProductsSlider', ProductsSliderPlugin, '[data-products-slider]');
PluginManager.register('CustomNavPills', CustomNavPillsPlugin, '[data-custom-nav-pills]');
PluginManager.register('ExpertenSlider', ExpertenSliderPlugin, '[data-experten-slider]');
PluginManager.register('ImFokusSlider', ImFokusSliderPlugin, '[data-im-fokus-slider]');
PluginManager.register('VideoPlay', VideoPlayPlugin, '[data-video-play]');
PluginManager.register('ProductHeroImages', ProductHeroImagesPlugin, '[data-product-hero-images]');
PluginManager.register('Typography', TypographyPlugin);
PluginManager.register('Preloader', PreloaderPlugin, '[data-preloader]');
PluginManager.register('TransitionLoader', TransitionLoaderPlugin, '[data-transition-loader]');
PluginManager.register('Header', HeaderPlugin, '[data-header]');

/*
run plugins
*/
document.addEventListener('readystatechange', (event) => {
    if (event.target.readyState === 'complete') {
        PluginManager.initializePlugins();
        ScrollTrigger.refresh();
    }
}, false);

window.addEventListener('DOMContentLoaded', () => {
    console.log('domcontentloaded scrolltrigger refresh');
    ScrollTrigger.refresh();
});
